import { IonToggle } from "@ionic/react";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { useFieldContext } from "@/form/common/hook";
import type { AppFormFieldLabelProps } from "@/form/components/field-label";
import type { AppFormFieldProps } from "@/form/components/types";
import { cn } from "@/lib/style/cva.config";

export type ToggleFieldProps = AppFormFieldLabelProps;

export const ToggleField = forwardRef<
  HTMLIonToggleElement,
  React.ComponentProps<typeof IonToggle> & AppFormFieldProps & ToggleFieldProps
>(function ToggleField(props, ref) {
  const { t } = useTranslation();
  const field = useFieldContext<boolean>();

  return (
    <IonToggle
      ref={ref}
      labelPlacement={props.labelPlacement ?? "start"}
      justify="space-between"
      children={t(`fields:${props.name ?? field.name}.label`)}
      name={field.name}
      checked={!!field.state.value}
      onIonChange={(event) => field.handleChange(event.detail.checked)}
      onIonBlur={field.handleBlur}
      disabled={field.state.meta.isValidating || field.form.state.isSubmitting}
      {...props}
      className={cn(
        field.state.meta.isTouched && "ion-touched",
        !!field.state.meta.errors && field.state.meta.errors.length > 0 && "ion-invalid",
        props.className,
      )}
    />
  );
});
